import { handleActions } from 'redux-actions';

import { NAMES as VIDEO_PLAYBACK_ACTIONS } from 'widget/redux/client/actions/change-playback-status';
import { NAME as SELECT_VIDEO } from 'widget/redux/client/actions/select-video';

import VIDEO_PLAYBACK_STATUSES from 'widget/constants/video-playback-status';

const defaultState = VIDEO_PLAYBACK_STATUSES.INITIAL;

const setPlayStatus = () => VIDEO_PLAYBACK_STATUSES.PLAYING;
const setPauseStatus = () => VIDEO_PLAYBACK_STATUSES.PAUSED;
const setEndedStatus = () => VIDEO_PLAYBACK_STATUSES.ENDED;
const resetStatus = () => VIDEO_PLAYBACK_STATUSES.INITIAL;

const setStatus = (state, { payload: status }) => status;


export default handleActions({
  [VIDEO_PLAYBACK_ACTIONS.PLAY]: setPlayStatus,
  [VIDEO_PLAYBACK_ACTIONS.PAUSE]: setPauseStatus,
  [VIDEO_PLAYBACK_ACTIONS.RESET]: resetStatus,
  [VIDEO_PLAYBACK_ACTIONS.END]: setEndedStatus,
  [VIDEO_PLAYBACK_ACTIONS.SET]: setStatus,
  [SELECT_VIDEO]: resetStatus,
}, defaultState);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/video-playback-status.js